import React, { Component } from 'react';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';
import PropTypes from 'prop-types';
import { KuposButton } from '.';

export default class SelectReturnTripModal extends Component {
  static propTypes = {};

  render() {
    return (
      <div className="common-bip-info-modal">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="bip-info-modal-container at-no-trips-modal">
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>
            <div className="at-no-trips-body">
              <div className="no-return-trip-icon-container">
                <img src="/static/images/icons/home/calender-no-trips.png" />
              </div>
              <div className="center-text" style={{ marginTop: 15 }}>
                <span className="font13 ">
                  {this.props.t('RESULTS_PAGE.SELECT_RETURN_TRIPS_HEAD')}
                </span>
              </div>
              <div className="center-text" style={{ marginTop: 15 }}>
                <span className="font11 ">
                  {this.props.t('TRANSLATIONS.SELECT_RETURN_SERVICES')}
                </span>
              </div>
            </div>

            <div className=" edit-bip-button bip-popup-button-container-edit">
              <KuposButton
                onClick={this.props.onContinue}
                className="bip-popup-button1 font12 bip-edit-button"
              >
                {this.props.t('HOME.OK_CONTINUE')}
              </KuposButton>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/SelectReturnTripModal.js